import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import {
  loginClear,
  loginBroker,
  loginBrokerClear,
  forgotPwdBroker,
  forgotPwdBrokerResponseClear,
  logoutClear,
  emailVerify,
  emailVerifyClear,
  loginBrokerResponse,
} from "../redux/auth/actions";
import {
  applyTheme,
  clickStreamUser,
  decryptPassword,
  emailValidation,
  encryptPassword,
  isMainDomain,
  LOGIN_CHANNEL,
  logoutClearSession,
  logoutFunc,
  SessionKeys,
  setFavicon,
  UserIsLoggedIn,
} from "../utils/AppUtils";
import { impersonateUser, impersonateUserResponseClear, userDetailBroker } from "../redux/user/actions";
import axios from "axios";
import CONFIG from "../utils/config";
import { objectToFormData } from "../api/data";
import { LinearProgress } from "@mui/material";
import Spinner from "react-bootstrap/Spinner";
import ConfirmModal from "../components/modal/ConfirmModal";
import { myCart } from "../redux/Cart/actions";
import {
  getBannerCardSummary,
  setUserPremium,
  setUserRole,
} from "../redux/user/actions";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import $ from "jquery";
import {
  getCoursesCategoriesFromBroker,
  getProductCategories,
} from "../redux/courses/actions";
import _ from "lodash";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import { GoogleLogin, googleLogout, useGoogleLogin } from "@react-oauth/google";
import SocialLoginComp from "../components/login/SocialLoginComp";
import InputPasswordComp from "../components/login/InputPasswordComp";
import { useAuth } from "../utils/auth";
import moment from "moment";
import { getLiveCalendarSessionList } from "../redux/events/actions";
import Loader from "../components/Loader/Loader";
import { isAndroid, isIOS } from "react-device-detect";
import ForgotPasswordComp from "../components/forgotPassComponents/ForgotPasswordComp";
import { getSubscriptionPlan } from "../redux/subscription/actions";
import API_LIST from "../utils/apiList";
import { fetchSubscribedData } from "../redux/checkout/actions";
import {
  getLoginLogo,
  getLoginLogoClear,
  getSmartBar,
  getSmartBarClear,
  setGoogleClientId,
  setGoogleClientIdClear,
} from "../redux/home/actions";
import ShimmerScreen from "../components/Layouts/ShimmerScreen";

const LoginPage = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const authProvider = useAuth();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const token = params.get("token");
  const sso = params.get("sso");
  const r = params.get("r");

  const actionImp = params.get("action");
  const impId = params.get("user_id");
  const impToken = params.get("token");

  const [isCompany, setIsCompany] = useState(false);
  const [company, setCompany] = useState("");
  const [loginImage, setLoginImage] = useState("")
  // const { company } = useParams();

  const domainArray = window.location.host.split('.');
  const subDomain = domainArray[0];

  let redirectPath = "/home";
  console.log("");
  if (localStorage.getItem(SessionKeys.LOCATION_PATH_REDIRECT)) {
    const locationPath = JSON.parse(
      localStorage.getItem(SessionKeys.LOCATION_PATH_REDIRECT)
    );
    if (!_.isEmpty(locationPath)) {
      redirectPath = locationPath.path;
      if (locationPath.query) {
        redirectPath = redirectPath + "/" + locationPath.query;
      }
      // localStorage.removeItem(SessionKeys.LOCATION_PATH_REDIRECT);
    }
  }
  if (redirectPath.includes(company)) {
    redirectPath = "/home";
  }

  const impersonateRes = useSelector((state) => state.user.impersonateUserData);
  const loginLogo = useSelector((state) => state.home.loginLogo);
  const googleClientId = useSelector((state) => state.home.googleClientId);
  const auth = useSelector((state) => state.auth.auth);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const emailVerifyRes = useSelector((state) => state.auth.emailVerify);
  var forgotRes = useSelector((state) => state.auth.forget_pwd_broker_response);
  const userDetailRes = useSelector((state) => state.user.userBroker);

  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [formError, setFormError] = useState("");
  const [forgetEmailError, setForgetEmailError] = useState("");
  const [isSentResetLink, setIsSentResetLink] = useState(false);
  const [formSuccess, setFormSuccess] = useState("");
  const [show, setShow] = useState(false);
  const [forgetEmail, setForgetEmail] = useState("");
  const [isChecked, setIsChecked] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const [isLoadingLogin, setIsLoadingLogin] = useState(false);
  const [dayParts, setDayParts] = useState("morning");
  const [confirmModal, setConfirmModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);

  const [impersonateAPICalled, setimpersonateAPICalled] = useState(false);

  const [showModalMsg, setShowModalMsg] = useState(
    "Profile updated successfully"
  );
  const [initialValue, setInitialValue] = useState({
    email: localStorage.getItem('redirect_email') ? localStorage.getItem('redirect_email') : "",
    password: "",
  });
  const [companyLogo, setCompanyLogo] = useState("");

  const [loginType, setLoginType] = useState(0); //to be change name
  const [currentWeekStart, setCurrentWeekStart] = useState(
    moment().startOf("week")
  );
  const [isForgotPassClick, setIsForgotPassClick] = useState(false);
  const [companyId, setCompanyId] = useState("")

  useEffect(() => {
    if(!isMainDomain()) {
      const domainArray = window.location.host.split('.');
    const subDomain = domainArray[0];
    localStorage.setItem(SessionKeys.LOGIN_COMPANY, subDomain)
      setCompany(subDomain);
      setIsCompany(true);
      if (!_.isEmpty(location.state?.path)) {
        redirectPath = location.state?.path;
        if (location.state?.query) {
          redirectPath = redirectPath + "/" + location.state?.query;
        }
      }
    } else {
    if (!_.isEmpty(location.state?.path)) {
      redirectPath = location.state?.path;
      if (location.state?.query) {
        redirectPath = redirectPath + "/" + location.state?.query;
      }
      if (location.state?.company) {
        setCompany(localStorage.getItem(SessionKeys.LOGIN_COMPANY));
        setIsCompany(true);
      } else {
        setLoginImage("/images/login_img.jpg")
      }
    } else {
      setLoginImage("/images/login_img.jpg")
    }
  }
  }, [location]);

  useEffect(() => {

    console.log("redir--useeffect", redirectPath)
  }, [redirectPath]);

  useEffect(() => {
    if (localStorage.getItem('redirect_email')) {
      setInitialValue({
        email: localStorage.getItem('redirect_email'),
        password: ""
      })
    }
  }, [dispatch])

  useEffect(() => {
    getGreetings();
    setCompanyName(window.location.host.split(".")[0]);
    window.runCookie();
    // i18n.changeLanguage('en')
  });


  useEffect(()=>{

    if(actionImp==="start_imp"){
      confirmAction();
    }

  },[actionImp])

  const confirmAction = () => {
      setimpersonateAPICalled(true);
      setIsLoadingLogin(true);
      logoutFunc(dispatch);
      dispatch(
        impersonateUser({
          module: "impersonate-user",
          postData: {
            user_id: impId,
            token: impToken,
            action: "start_imp",
            login_type:"broker_admin"
          },
        })
      );
    };
  
    useEffect(() => {
      if (!_.isEmpty(impersonateRes) && impersonateAPICalled) {
        console.log("check--", impersonateRes);
        if (impersonateRes?.status === "success") {
          let userData = impersonateRes?.payload?.payload?.user_data;
          localStorage.setItem(SessionKeys.IS_IMPERSONATED, true);
          localStorage.setItem(
            SessionKeys.LOGGED_IN_USER_TOKEN,
            localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
          );
          localStorage.setItem(
            SessionKeys.LOGGED_IN_USER_ID,
            localStorage.getItem(SessionKeys.USER_ID)
          );
          localStorage.setItem(
            SessionKeys.API_TOKEN_BROKER,
            impersonateRes?.payload?.payload?.token
          );
          localStorage.setItem(SessionKeys.USER_ID, userData?.user_id);
          localStorage.setItem(SessionKeys.FIRST_NAME, userData?.firstname);
          localStorage.setItem(SessionKeys.LAST_NAME, userData?.lastname);
          dispatch(
            userDetailBroker({
              module: "getOrderDetailBroker",
              apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            })
          )
          if (_.isArray(userData?.role)) {
            // console.log("USER ROLE", roleArray);
  
            if (userData?.role.includes("customer")) {
              dispatch(setUserRole("customer"));
            } else if (userData?.role.includes("realtor")) {
              dispatch(setUserRole("realtor"));
            } else if (userData?.role.includes("manager")) {
              dispatch(setUserRole("manager"));
            } else if (userData?.role.includes("pmpro_membership_manager")) {
              // console.log("USER ROLE PMPRO", roleArray);
              dispatch(setUserRole("broker"));
            } else if (userData?.role.includes("instructor")) {
              dispatch(setUserRole("instructor"));
            } else if (userData?.role.includes("host")) {
              dispatch(setUserRole("host"));
            } else if (userData?.role.includes("broker_admin")) {
              dispatch(setUserRole("admin"));
            }
          }
          dispatch(
            loginBrokerResponse({
              payload: {
                user: {
                  user_id: userData?.user_id,
                  username: userData?.username,
                  firstname: userData?.firstname,
                  middlename: userData?.middlename,
                  lastname: userData?.lastname,
                  email: userData?.email,
                  bot_token: userData?.bot_token,
                  ai_roleplay_token: userData?.ai_roleplay_token,
                  profile_img: userData?.profile_img,
                  isProfileCompleted: userData?.isProfileCompleted,
                  isOnboarding: userData?.isOnboarding,
                  isPremium: userData?.isPremium,
                  profile_img_check: userData?.profile_img_check,
                  city: userData?.city,
                  state: userData?.state,
                  designation: userData?.designation,
                  timezone: userData?.timezone,
                  timezoneAbbr: userData?.timezoneAbbr,
                  profile_complete: userData?.profile_complete,
                  broker_id: userData?.broker_id,
                  broker_name: userData?.broker_name,
                  zoom_id: userData?.zoom_id,
                  company_id: userData?.company_id,
                  role: userData?.role,
                  IsGuest: userData?.IsGuest,
                  ip_address: userData?.ip_address,
                  broker_of_records: userData?.broker_of_records,
                  isagreed: userData?.isagreed,
                  complete_tour: userData?.complete_tour,
                  guest_end_date: userData?.guest_end_date,
                  display_subscription_menu: userData?.display_subscription_menu,
                  is_parent: userData?.is_parent,
                  parent_name: userData?.parent_name,
                  branding: userData?.branding,
                  apply_theme: userData?.apply_theme,
                  branding_primary_color_1: userData?.branding_primary_color_1,
                  branding_primary_color_2: userData?.branding_primary_color_2,
                  branding_company_logo: userData?.branding_company_logo,
                  is_google_sso_enabled: userData?.is_google_sso_enabled,
                  is_ms_sso_enabled: userData?.is_ms_sso_enabled,
                  is_sso_enabled: userData?.is_sso_enabled,
                  partner_menu: userData?.partner_menu,
                  courseURL: userData?.courseURL,
                },
                apiToken: impersonateRes?.payload?.payload?.token,
              },
            })
          );
          // getMyTeamsList();
          dispatch(impersonateUserResponseClear());
          navigate("/home");
          setTimeout(() => {
            setIsLoadingLogin(false);
          }, 2000);
        } else {
        }
        setimpersonateAPICalled(false);
      }
      // return () => {
      //   dispatch(impersonateUserResponseClear());
      // };
    }, [impersonateRes]);


  useEffect(() => {
    if ((isCompany && company && actionImp!=="start_imp")) {
      setIsLoadingLogin(true)
      dispatch(
        getLoginLogo({
          URL: `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.BROKER_API.LOGIN_LOGO_URL}`,
          payload: {
            company_ref: company,
            // email: localStorage.getItem('redirect_email')
          },
          isJSON: true,
          method: "post",
        })
      );
    }
  }, [company, isCompany]);

  useEffect(() => {
    if (!_.isEmpty(loginLogo)) {
      setIsLoadingLogin(false);
      if (
        loginLogo.status === "success" &&
        !_.isEmpty(loginLogo.payload?.data)
      ) {
        let data = loginLogo.payload.data.sso_response;

        if (loginLogo.payload.data.login_image_url) {
          setLoginImage(loginLogo.payload.data.login_image_url);
        } else {
          setLoginImage("/images/login_img.jpg")
        }

        if (loginLogo.payload.data.branding_primary_color_1) {
          document.title = loginLogo.payload.data.company_name; 
          if(loginLogo.payload.data.provider_image){
          setFavicon(loginLogo.payload.data.provider_image)}
          const colorElement1 = loginLogo.payload.data.branding_primary_color_1;
          const colorElement2 = loginLogo.payload.data.branding_primary_color_2;
          $("html").css(
            "--color-element-1",
            colorElement1 ? colorElement1 : CONFIG.COLOR_ELEMENT_1
          );
          $("html").css(
            "--color-element-2",
            colorElement2 ? colorElement2 : CONFIG.COLOR_ELEMENT_2
          );
        }

        if (data?.is_sso_enabled === "1") {
          if (!_.isEmpty(data?.ms) && data?.ms?.is_enabled === "1") {
            setCompanyLogo(loginLogo.payload.data.company_logo);
            window.open(data?.ms?.url, "_self");
            dispatch(setGoogleClientIdClear());
            setTimeout(() => {
              dispatch(getLoginLogoClear());
            }, 2000);
          } else {
            if (!_.isEmpty(googleClientId)) {
              setTimeout(() => {
                setLoginType(2);
                setCompanyLogo(loginLogo.payload.data.company_logo);
                dispatch(setGoogleClientIdClear());
                setTimeout(() => {
                  dispatch(getLoginLogoClear());
                }, 2000);
              }, 1000);
            }
          }
        } else {
          setCompanyLogo(loginLogo.payload.data.company_logo);
          setLoginType(1);
          dispatch(setGoogleClientIdClear());
          setTimeout(() => {
            dispatch(getLoginLogoClear());
          }, 2000);
        }
      } else {
        setCompanyLogo("");
        setLoginImage("/images/login_img.jpg")
        dispatch(setGoogleClientIdClear());
        setTimeout(() => {
          dispatch(getLoginLogoClear());
        }, 2000);
      }



    }
  }, [loginLogo, googleClientId]);

  useEffect(() => {
    console.log("resOut:", companyId);
    if (!_.isEmpty(companyId)) {  //&& CONFIG.ENV != 'DEV'
      axios.get(process.env.PUBLIC_URL + "key.json")
        .then(res => {
          const dataRes = res?.data;
          console.log("resOut1:", dataRes[companyId]);
          dispatch(setGoogleClientId(dataRes[companyId]));
        })
    }
  }, [companyId])

  useEffect(() => {
    if (!_.isEmpty(loginLogo)) {
      if (
        loginLogo.status === "success" &&
        !_.isEmpty(loginLogo.payload?.data)
      ) {
        setCompanyId(loginLogo.payload.data.company_id);

      } else {

      }
    }
  }, [loginLogo]);

  useEffect(() => {
    if (
      token !== null &&
      !_.isEmpty(token) &&
      sso !== null &&
      !_.isEmpty(sso)
    ) {
      console.log("testValueToken: ", token);
      if (sso === "true") {
        setIsLoadingLogin(true);
        //for mobile application sending token callback
        if (isAndroid || isIOS) {
          try {
            // alert("Window CallbackHanlder");
            if (window.callbackHandler !== undefined) {
              let obj = {
                method: "msToken",
                token: token,
              };
              window.callbackHandler.postMessage(JSON.stringify(obj));
            }
            if (window.webkit !== undefined) {
              if (window.webkit.messageHandlers.callbackHandler !== undefined) {
                let obj = {
                  method: "msToken",
                  token: token,
                };
                window.webkit.messageHandlers.callbackHandler.postMessage(
                  JSON.stringify(obj)
                );
              }
            }
          } catch (err) { }
        }

        setTimeout(() => {
          dispatch(
            loginBroker({
              action: "realtor_login_from_php",
              token: token,
            })
          );
        }, 500);
      }
    }
  }, [token, sso]);

  useEffect(() => {
    clickStreamUser("login-page", {});
  }, [dispatch]);

  useEffect(() => {
    localStorage.setItem("CompanyName", companyName);
  }, [companyName]);

  // useEffect(() => {
  //   console.log("formErr: ", formError + " " + formSuccess);
  //   if (formError || formSuccess) {
  //     setTimeout(() => {
  //       console.log("timeout");
  //       formError ? setFormError("") : setFormSuccess("");
  //     }, 5000);
  //   }
  // }, [formError, formSuccess]);

  useEffect(() => {
    setLoginType(0);
    if (document.getElementById("id_page_404") !== null) {
      document.getElementById("id_page_404").style.display = "none";
    }
  }, []);

  useEffect(() => {
    if (location.state?.logout) {
      setFormSuccess("You have been logged out successfully.");
      navigate("", { replace: true });
    } else if (location.state?.relogin) {
      setFormSuccess("Please relogin to continue.");
      navigate("", { replace: true });
    } else if (location.state?.canLogin) {
      setFormSuccess("Password is set successfully, Sign in now.");
      navigate("", { replace: true });
    } else if (location.state?.sessionExpired) {
      setFormSuccess("Session is expired, relogin to continue.");
      navigate("", { replace: true });
    } else if (location.state?.resetTokenExpired) {
      setFormSuccess("Link already used.");
      navigate("", { replace: true });
    }
  }, [location]);

  function setWithExpiry(key, value, ttl) {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);


    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item?.value;
  }

  useEffect(() => {
    // console.log("location: ", window.location);
    // dispatch(loginClear())
    if (
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) != null &&
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== "" &&
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== undefined && actionImp!=="start_imp"
    ) {
      // console.log(
      //   "aggreed value",
      //   localStorage.getItem(SessionKeys.IS_AGGREED)
      // );
      if (localStorage.getItem(SessionKeys.IS_AGGREED) === "true") {
        authProvider.login(authBroker);
        console.log("redir--2", redirectPath)
        navigate(redirectPath, { replace: true });
        // navigate("/home");
      } else {
        navigate("/privacy-and-terms");
      }
    } else {
      if (
        localStorage.getItem(SessionKeys.IS_REMEMBERED) != null &&
        localStorage.getItem(SessionKeys.IS_REMEMBERED)
      ) {
        const rememberedEmail = getWithExpiry(SessionKeys.EMAIL);
        if (rememberedEmail) {
          setEmail(rememberedEmail);
        }
        // setEmail(localStorage.getItem(SessionKeys.EMAIL));
        const rememberedPass = getWithExpiry(SessionKeys.PASS);
        const encryptedPassword = rememberedPass;
        let decryptedPassword = decryptPassword(encryptedPassword);
        setPassword(decryptedPassword);
        setInitialValue({
          email: rememberedEmail ? rememberedEmail : "",
          password: decryptedPassword,
        });
      }
    }
  }, []);

  useEffect(() => {
    console.log(authBroker);
    if (!_.isEmpty(authBroker)) {
      setIsLoadingLogin(false);
    }
    if (
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== null &&
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== "" &&
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== undefined && actionImp!=="start_imp"
    ) {
      console.log("inside authBroker", authBroker);
      if (authBroker.status === "success") {
        localStorage.removeItem(SessionKeys.LOGIN_COMPANY);
        // console.log('auth: ', auth.payload)
        setFormSuccess(authBroker.payload.message);
        dispatch(
          userDetailBroker({
            module: "getOrderDetailBroker",
            apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          })
        );
        LOGIN_CHANNEL.onmessage = (event) => {
          if (event.data && event.data?.login) {
            window.location.reload();
          }
        };
        UserIsLoggedIn();
        const roleArray = authBroker.payload.user.role;
        if (_.isArray(roleArray)) {
          // console.log("USER ROLE", roleArray);

          if (roleArray.includes("customer")) {
            dispatch(setUserRole("customer"));
          } else if (roleArray.includes("realtor")) {
            dispatch(setUserRole("realtor"));
          } else if (roleArray.includes("manager")) {
            dispatch(setUserRole("manager"));
          } else if (roleArray.includes("pmpro_membership_manager")) {
            // console.log("USER ROLE PMPRO", roleArray);
            dispatch(setUserRole("broker"));
            localStorage.setItem(
              SessionKeys.BROKER_ID,
              authBroker.payload.user.user_id
            ); // IT WILL BE DYNAMIC
          } else if (roleArray.includes("instructor")) {
            dispatch(setUserRole("instructor"));
          } else if (roleArray.includes("host")) {
            dispatch(setUserRole("host"));
          } else if (roleArray.includes("broker_admin")) {
            dispatch(setUserRole("admin"));
          }
        } else {
          logoutClearSession();
          setFormError("Invalid user role.");
          setIsLoadingLogin(false);
          dispatch(loginClear());
          dispatch(loginBrokerClear());
        }

        const colorElement1 = authBroker.payload.user.branding_primary_color_1;
        const colorElement2 = authBroker.payload.user.branding_primary_color_2;
        $("html").css(
          "--color-element-1",
          colorElement1 ? colorElement1 : CONFIG.COLOR_ELEMENT_1
        );
        $("html").css(
          "--color-element-2",
          colorElement2 ? colorElement2 : CONFIG.COLOR_ELEMENT_2
        );

        if (localStorage.getItem(SessionKeys.SESSION_ID)) {
          syncLocalCart();
          localStorage.removeItem(SessionKeys.SESSION_ID);
        }

        let cookieArray = document.cookie.split(";");
        let acceptedCookie = [];
        let cookieConsentDate = "";
        for (let cookie of cookieArray) {
          if (cookie.includes("cc_cookie")) {
            let cookieData = cookie.split("e=")[1];
            let cookieInfo = JSON.parse(decodeURIComponent(cookieData));
            acceptedCookie = cookieInfo.categories;
            cookieConsentDate = cookieInfo.consent_date;
          }
        }
        window.captureMyEvents("loginSuccessfull", {
          email: authBroker.payload.user.email,
          userId: authBroker.payload.user.user_id,
          ipAddress: authBroker.payload.user.ip_address,
          acceptedCookie,
          cookieConsentDate,
        });
        dispatch(
          myCart({
            module: "myCart",
            email: authBroker?.payload?.user?.email,
          })
        );

        if (authBroker.payload.user.isPremium === "1") {
          dispatch(setUserPremium(true));
        }

        // dispatch(
        //   getSubscriptionPlan({
        //     URL: `${CONFIG.API_URL_BROKER}/${API_LIST.ECOM_API.GET_SUBSCRIPTION_PLAN}`,
        //     payload: {},
        //     isJSON: true,
        //     method: "post",
        //   })
        // );

        dispatch(
          fetchSubscribedData({
            method: "POST",
            URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.GET_SUBSCRIBED_DATA}`,
            payload: {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            },
            isJSON: true,
          })
        );

        if (authBroker.payload?.user?.config?.banner_strip !== "false") {
          dispatch(getSmartBarClear({}));
          dispatch(
            getSmartBar({
              module: "getSmartBar",
              postData: {
                token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
                  ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
                  : "",
              },
            })
          );
        }

        const branding = authBroker.payload.user.branding;

        if (authBroker.payload.user.apply_theme) {
          !_.isEmpty(branding) && applyTheme(branding);
        } else {
          if ($("body").hasClass("cus-bro-theme")) {
            $("body").removeClass("cus-bro-theme");
          }
        }
        // dispatchAPILiveCall();
        if (localStorage.getItem(SessionKeys.LOCATION_PATH_REDIRECT)) {
          const locationPath = JSON.parse(
            localStorage.getItem(SessionKeys.LOCATION_PATH_REDIRECT)
          );
          if (!_.isEmpty(locationPath)) {
            redirectPath = locationPath.path;
            if (locationPath.query) {
              redirectPath = redirectPath + "/" + locationPath.query;
            }

          }
        }
        setTimeout(() => {
          if (localStorage.getItem(SessionKeys.IS_AGGREED) === "true") {
            localStorage.removeItem(SessionKeys.LOCATION_PATH_REDIRECT);
            if (r) {
              let redirectUrl = atob(r);
              navigate(redirectUrl, { replace: true });
            }else if (authBroker.payload.user.courseURL) {
              navigate(authBroker.payload.user.courseURL);
            } else {
              authProvider.login(authBroker);
              console.log("redir--1", redirectPath)
              navigate(redirectPath, { replace: true });
            }
            // navigate("/home");
          } else {
            navigate("/privacy-and-terms");
          }
        }, 500);
      } else if (authBroker?.status === "error") {
        // console.log('authBroker', auth?.error?.message, authBroker?.error?.message)
        window.captureMyEvents("loginFailed", {
          message: authBroker?.error?.message,
          email: email,
        });
        logoutClearSession();
        setFormError(authBroker?.error?.message);
        setIsLoadingLogin(false);
        dispatch(loginClear());
        dispatch(loginBrokerClear());
      }
    }
    if (authBroker?.status === "error") {
      // console.log('authBroker', auth?.error?.message, authBroker?.error?.message)
      window.captureMyEvents("loginFailed", {
        message: authBroker?.error?.message,
        email: email,
      });
      logoutClearSession();
      setFormError(authBroker?.error?.message);
      setIsLoadingLogin(false);
      dispatch(loginClear());
      dispatch(loginBrokerClear());
    }
  }, [auth, navigate, authBroker]);

  useEffect(() => {
    setShowLoader(false);
    // console.log("forgotRes: ", forgotRes);
    if (
      forgotRes != null &&
      forgotRes !== undefined &&
      Object.entries(forgotRes).length > 0
    ) {
      switch (forgotRes.status) {
        case "success":
          setIsSentResetLink(true);
          // setShowModalMsg("Password reset link has been sent to your email.");
          // setConfirmModal(true);
          // setIsConfirm(false);
          // setShow(false);
          dispatch(forgotPwdBrokerResponseClear());
          break;

        case "error" || false:
          // console.log("error", forgotRes.error.message);
          const msg = forgotRes.error.message
            ? forgotRes.error.message
            : "Error sending password reset link.";
          // setForgetEmailError("Please enter valid email address.");
          setTimeout(() => {
            setForgetEmailError("");
          }, 2000);
          setIsSentResetLink(true);
          dispatch(forgotPwdBrokerResponseClear());
          break;

        default:
      }
      // return () => {
      //   console.log('clear')
      //   dispatch(forgotPwdResponseClear())
      // }
    }
  }, [forgotRes]);

  const getGreetings = () => {
    var date = new Date();
    var hours = date.getHours();
    if (hours >= 0 && hours < 12) {
      setDayParts("morning");
    } else if (hours >= 12 && hours < 16) {
      setDayParts("afternoon");
    } else if (hours >= 16 && hours < 24) {
      setDayParts("evening");
    }
  };

  const myFunction = () => {
    var x = document.getElementById("passInput");
    var y = document.getElementById("eyeImg");
    if (x.type === "password") {
      x.type = "text";
      y.src = "/images/view.png";
    } else {
      x.type = "password";
      y.src = "/images/private.png";
    }
  };

  const handleSubmit = (values) => {
    setFormSuccess("");
    let email = values.email;
    let password = values.password;
    dispatch(loginClear());
    if (isChecked) {
      setWithExpiry(SessionKeys.EMAIL, email, 30 * 24 * 60 * 60 * 1000);
      localStorage.setItem(SessionKeys.IS_REMEMBERED, true);
      // localStorage.setItem(SessionKeys.EMAIL, email);
      const encryptedPassword = encryptPassword(password);
      setWithExpiry(SessionKeys.PASS, encryptedPassword, 30 * 24 * 60 * 60 * 1000);
      // localStorage.setItem(SessionKeys.PASS, encryptedPassword);
    } else {
      localStorage.setItem(SessionKeys.IS_REMEMBERED, false);
      localStorage.setItem(SessionKeys.EMAIL, "");
      localStorage.setItem(SessionKeys.PASS, "");
    }
    setIsLoadingLogin(true);
    dispatch(
      loginBroker({
        action: "realtor_login",
        email: email,
        password: password,
        ref: company,
      })
    );
  };

  const loginWithPassword = () => {
    if (!emailValidation(email)) {
      setFormError("");
      return;
    }
    setFormSuccess("");
    // let email = email;
    // let password = password;
    dispatch(loginClear());
    if (isChecked) {
      setWithExpiry(SessionKeys.EMAIL, email, 30 * 24 * 60 * 60 * 1000);
      localStorage.setItem(SessionKeys.IS_REMEMBERED, true);
      // localStorage.setItem(SessionKeys.EMAIL, email);
      const encryptedPassword = encryptPassword(password);
      setWithExpiry(SessionKeys.PASS, encryptedPassword, 30 * 24 * 60 * 60 * 1000);
      // localStorage.setItem(SessionKeys.PASS, encryptedPassword);
    } else {
      localStorage.setItem(SessionKeys.IS_REMEMBERED, false);
      localStorage.setItem(SessionKeys.EMAIL, "");
      localStorage.setItem(SessionKeys.PASS, "");
    }
    setIsLoadingLogin(true);
    dispatch(
      loginBroker({
        action: "realtor_login",
        email: email,
        password: password,
        ref: company
      })
    );
  };

  function handleShow(value) {
    setShow(value);
  }

  const sendForgotPassLink = () => {
    if (emailValidation(forgetEmail)) {
      // setForgetEmailError("");
      setShowLoader(true);
      const params = {
        "reset-email": forgetEmail,
        "pwdforgot-btn": "FORGOT PWD",
      };
      // console.log(params);
      // dispatch(forgotPwd(params))
      dispatch(
        forgotPwdBroker({
          module: "forgot-password-link",
          postData: {
            "reset-email": forgetEmail,
          },
        })
      );
    } else {
      // setShowModalMsg("Invalid email.");
      // setConfirmModal(true);
      // setIsConfirm(false);
      setForgetEmailError("Please enter valid email address.");
    }
  };

  const renderModal = () => {
    return (
      <Modal
        show={show}
        fullscreen={false}
        onHide={() => setShow(false)}
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: "white" }}>
          <Modal.Title>Forgot Password</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "white" }}>
          <ForgotPasswordComp
            showLoader={showLoader}
            isSentResetLink={isSentResetLink}
            setForgetEmail={setForgetEmail}
            forgetEmailError={forgetEmailError}
            sendForgotPassLink={sendForgotPassLink}
            handleShow={handleShow}
            setIsForgotPassClick={setIsForgotPassClick}
          />
        </Modal.Body>
      </Modal>
    );
  };

  const stripeFormSchema = Yup.object().shape({
    email: Yup.string().required("Please enter email"),
    password: Yup.string().required("Please enter password"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },

    onSubmit: (values) => {
      // console.log("value: ", values);
      handleSubmit(values.email, values.password);
    },
  });

  const verifyEmail = () => {
    if (!emailValidation(email)) {
      setFormError("");
      return;
    }
    setIsLoadingLogin(true);
    if (isChecked) {
      setWithExpiry(SessionKeys.EMAIL, email, 30 * 24 * 60 * 60 * 1000);
      localStorage.setItem(SessionKeys.IS_REMEMBERED, true);
      localStorage.setItem(SessionKeys.EMAIL, email);
    } else {
      localStorage.setItem(SessionKeys.IS_REMEMBERED, false);
      localStorage.setItem(SessionKeys.EMAIL, "");
    }
    setFormSuccess("");
    setFormError("");
    dispatch(
      emailVerify({
        module: "getEmailVerify",
        postData: {
          email: email,
        },
      })
    );
  };

  useEffect(() => {
    console.log(emailVerifyRes);
    if (!_.isEmpty(emailVerifyRes)) {
      setIsLoadingLogin(false);
      if (emailVerifyRes?.status === "success") {
        let data = emailVerifyRes?.payload?.payload;
        if (data?.is_sso_enabled === "1") {
          if (!_.isEmpty(data?.ms) && data?.ms?.is_enabled === "1") {
            window.open(data?.ms?.url, "_self");
          } else {
            setLoginType(2);
          }
        } else {
          setLoginType(1);
        }
        dispatch(emailVerifyClear());
      } else {
        setFormError(emailVerifyRes?.error?.message);
      }
      dispatch(emailVerifyClear());
    }
  }, [emailVerifyRes]);

  const syncLocalCart = async () => {
    await axios.post(
      `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.SYNC_LOCAL_CART}`,
      {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        session_id: localStorage.getItem(SessionKeys.SESSION_ID),
      }
    );
  };

  return (
    <>
      <Loader start={isLoadingLogin || (actionImp==="start_imp")} />
      <div className="login-ary">
        <section className="login-sec ">
          <div className="login-container ">
            {/* <div className="bannerlog-image d-block d-md-none image-login">
              <img className="img-fluid" alt="" src="/images/login_img.jpg" />
            </div> */}
            {/* <div className="header-border"></div> */}
            <div className="container-fluid">
              <div className="row bglogin">
                <div className="col-xl-7 col-lg-6 col-sm-12 col-12 image-login">
                  {
                    loginImage ?
                      <img
                        className="img-fluid"
                        src={loginImage}
                        alt="home-scene-login"
                      />
                      : ""
                  }
                </div>
                <div className="col-xl-5 col-lg-6 col-sm-12 col-12 ttxt">
                  {!isForgotPassClick ? (
                    <div className="login-text">
                      <div
                        className="text-center lgo-box cursor-pointer"
                        onClick={() => navigate("/")}
                      >
                        {isCompany ? (
                          companyLogo ? (
                            <img
                              className="company_logo_login"
                              src={companyLogo}
                              alt="Logo"
                            // height={"6rem"}
                            />
                          ) : (
                            <div className="d-flex justify-content-center">
                              <ShimmerScreen
                                case={"circle"}
                                width="10rem"
                                height="10rem"
                              />
                            </div>
                          )
                        ) : (
                          <img src="/images/logo/Untitled-6.png" alt="logo" />
                        )}
                      </div>

                      <h2 className="text-center logtitle">
                        {t("Sign in to your account")}
                      </h2>
                      <p className="ms-2-message text-center">
                        {(subDomain === "c21-xselapp" || subDomain === "c21corp-b2c-learner-uat") ? "You can access the platform from Your Organization's Google Apps" : "Welcome back! Please enter your details."}
                      </p>
                      {(subDomain === "c21-xselapp" || subDomain === "c21corp-b2c-learner-uat") ? <>
                        <div style={{ textAlign: "center" }}>
                          <img className="img-fluid" style={{ width: "240px" }} src="https://cdn.training.com/xsel/image/4b455da0-f88f-42af-ae79-4341ad88503b.png" />
                        </div>
                      </>
                        : <>
                          {loginType < 2 ? (
                            <div>
                              <div className="mb-2 login-msg">

                                {formSuccess ? (
                                  <div>{formSuccess}</div>
                                ) : formError ? (
                                  <div style={{ color: "red" }}>{formError}</div>
                                ) : (
                                  ""
                                )}
                              </div>
                              <Formik
                                initialValues={initialValue}
                                validationSchema={stripeFormSchema}
                                validateOnChange={false}
                                validateOnBlur={false}
                                onSubmit={handleSubmit}
                                enableReinitialize
                              >
                                {(formik) => {
                                  const { handleSubmit } = formik;

                                  return (
                                    <form onSubmit={handleSubmit}>
                                      {loginType === 1 && false && (
                                        <div onClick={() => {
                                          setLoginType(0);
                                        }} title="Back" className="back-btn-google-login mb-3">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none"><path d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331" stroke="#6941C6" strokeWidth="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                        </div>

                                      )}
                                      {(loginType === 0 || true) && <div className="input-text ">
                                        <label
                                          htmlFor="password"
                                          className="input__label"
                                        >
                                          {t("Email")}
                                        </label>
                                        <input
                                          className="input__field"
                                          name="email"
                                          type="email"
                                          placeholder="Enter your email"
                                          value={email}
                                          onChange={(evt) =>
                                            setEmail(evt.target.value)
                                          }
                                          // onChange={formik.handleChange}
                                          // value={formik.values.email}
                                          required
                                          autoComplete="on"
                                        />
                                      </div>}
                                      {(loginType === 1 || true) && <InputPasswordComp
                                        myFunction={myFunction}
                                        formik={formik}
                                        setPassword={setPassword}
                                        password={password}
                                        setIsSocial={setLoginType} />}

                                      <div className="form-row d-flex">
                                        <div className="col-6 form-check cursor-pointer rember">
                                          <input
                                            className="form-check-input cursor-pointer"
                                            type="checkbox"
                                            value=""
                                            id="flexCheckDefault"
                                            onChange={(e) => {
                                              setIsChecked(e.target.checked);
                                            }}
                                            checked={isChecked}
                                          />
                                          <label
                                            className="form-check-label cursor-pointer"
                                            htmlFor="flexCheckDefault"
                                          >
                                            {t("Remember for 30 days")}
                                          </label>
                                        </div>
                                        <div className="col-6 text-right">
                                          <a
                                            href="/"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setForgetEmailError("");
                                              setIsSentResetLink(false);

                                              setIsForgotPassClick(true);

                                              // handleShow(true);
                                            }}
                                            className="forgot-pwd"
                                          >
                                            {t("Forgot Password?")}
                                          </a>
                                        </div>
                                      </div>

                                      <p className="">
                                        <button
                                          className={`default-btn signinBtn mt-4 ${isLoadingLogin ? "isLogin" : ""
                                            }`}
                                          disabled={isLoadingLogin ? true : ""}
                                          onClick={() => { loginType === 0 && false ? verifyEmail() : loginWithPassword() }}
                                        >
                                          {isLoadingLogin ? (
                                            <Spinner
                                              as="span"
                                              animation="border"
                                              size="sm"
                                              role="status"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            t(loginType === 0 && false ? "Next" : "Sign in")
                                          )}
                                        </button>
                                      </p>
                                    </form>
                                  );
                                }}
                              </Formik>
                            </div>
                          ) : (
                            <>
                              <SocialLoginComp /*login with google component */
                                setIsSocial={setLoginType}
                              />
                              <div className="don-have-account">
                                If you have Guest Account, please{" "}
                                <strong
                                  onClick={() => {
                                    // navigate("/sign-up?p=1");
                                    setLoginType(0)
                                  }}
                                >
                                  click here
                                </strong>
                              </div>
                            </>
                          )}
                        {isCompany  ? (
                            ""
                          ) : (
                            <>
                              <div className="don-have-account">
                                Don’t have an account?{" "}
                                <strong
                                  onClick={() => {
                                    navigate("/sign-up?p=1");
                                  }}
                                >
                                  Sign up
                                </strong>
                              </div>
                              {false && <div className="bying-brokarage">
                                Buying for your brokerage, instead?
                              </div>}
                            </>
                          )}
                        </>}
                    </div>
                  ) : (
                    <div className="fotgot-sec">
                      <ForgotPasswordComp
                        showLoader={showLoader}
                        isSentResetLink={isSentResetLink}
                        setForgetEmail={setForgetEmail}
                        forgetEmailError={forgetEmailError}
                        sendForgotPassLink={sendForgotPassLink}
                        handleShow={handleShow}
                        setIsForgotPassClick={setIsForgotPassClick}
                      />
                    </div>
                  )}
                  {/* <div className="d-none d-md-block footer-title">
                    @{new Date().getFullYear()} - NIIT - All Rights Reserved
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {renderModal()}
      </div>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        isConfirm={isConfirm}
      />
    </>
  );
};

export default LoginPage;
